import { render, staticRenderFns } from "./polygon.vue?vue&type=template&id=96f24aba&scoped=true"
import script from "./polygon.vue?vue&type=script&lang=js"
export * from "./polygon.vue?vue&type=script&lang=js"
import style0 from "./polygon.vue?vue&type=style&index=0&id=96f24aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f24aba",
  null
  
)

export default component.exports